import React from "react";
import "./RenewPolicy.css";
import Renew from "../../../Images/Refrence/Renew-coin.svg";
import ProductLogo from "../../ProductLogo";

const RenewPolicy = ({ policyList }) => {
    console.log(policyList, 'Recent Policy');
  const currentDate = new Date();
  const [day, month, year] = policyList.PolicyEndDate.split("/");
  const policyEndDate = new Date(`${year}-${month}-${day}`);
  const timeDifference = policyEndDate.getTime() - currentDate.getTime();
  const daysToExpire = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  return (
    <>
      <div className="Renew-Card">
              <div className="Renew-Card-Icon">
                  <ProductLogo item={policyList} />
        </div>
        <div className="Renew-Card-CNT">
          <b>
           {policyList.VehicleNo}
          </b>
          <div className="">
            <small>{policyList.PolicySubType} Policy</small>
          </div>
          <div className="Expire">
            <span>Expiring in {daysToExpire} days</span>
          </div>
          <div className="HidIng_Elms mt-2">
            <button className="btn btn-renew">Renew Now </button>
            <small>
              <img alt="" src={Renew} /> in just 2 clicks
            </small>
          </div>
        </div>
        <div className="HidIng_Elem">
          <button className="btn btn-renew">Renew Now </button>
          <div>
            <small>
              <img alt="" src={Renew} /> in just 2 clicks
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default RenewPolicy;
